
import React, { Component,createRef } from 'react';
import { DateRangePicker } from 'react-date-range';
import { th,enUS } from 'date-fns/locale';
import { addDays } from 'date-fns';
import { bookingStartDate, defaultStay, startOfDay, stayPayload } from './bookingDates';


const thaiMonths = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
  'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
  'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
];

const englishMonths = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
const customEnglishLocale = {
  ...enUS,
  localize: {
    ...enUS.localize,
    day: (n) => {
      const days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
      return days[n];
    },
  },
};

class CalendarMobile extends Component {
  constructor(props) {
    super(props);

    const { from, to } = defaultStay(this.props.openingDate);
    const langThai = document.querySelector('html[lang="th"]');

    this.state = {
      from,
      to,
      showCalendar: false,
      dateFromValue: !langThai ? this.formatDate(from) : this.formatDateThailan(from),
      dateToValue: !langThai ? this.formatDate(to) : this.formatDateThailan(to),
    };
    this.calendarRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
    if (this.props.setCalendarData) {
      this.props.setCalendarData(stayPayload(this.state.from, this.state.to));
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.openingDate === this.props.openingDate) {
      return;
    }
    const { from, to } = defaultStay(this.props.openingDate);
    const langThai = document.querySelector('html[lang="th"]');
    this.setState({
      from,
      to,
      dateFromValue: !langThai ? this.formatDate(from) : this.formatDateThailan(from),
      dateToValue: !langThai ? this.formatDate(to) : this.formatDateThailan(to),
    }, () => {
      if (this.props.setCalendarData) {
        this.props.setCalendarData(stayPayload(from, to));
      }
    });
  }

  handleClickOutside = (event) => {
    if (this.calendarRef.current && !this.calendarRef.current.contains(event.target)) {
      this.setState({ showCalendar: false });
    }
  };

  handleInputFocus = (type) => {
    this.setState({ showCalendar: type });
  };

  handleCalendarIconClick = () => {
    this.setState({
      showCalendar: false
    });
  }  

  formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  };
  formatDateThailan = (date) => {
    return date.toLocaleDateString("th-TH", {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });
  };

  handleDayClick = (ranges) => {
    const { selection } = ranges;
    let { startDate, endDate } = selection;

    this.setState((prevState) => {
      let { from, to } = prevState;
      let newFrom = from;
      let newTo = to;
      if (prevState.showCalendar === "from") {
        newFrom = startDate;
        // const fromThai = new Date(newFrom);
        // const toThai = new Date(newTo);
        // fromThai.setFullYear(newFrom.getFullYear() + 543);
        // toThai.setFullYear(newTo.getFullYear() + 543);
        if (to && newFrom >= to) {
          newTo = new Date(newFrom);
          // toThai.setDate(newTo.getDate() + 1);
          newTo.setDate(newTo.getDate() + 1);
        }
        // this.setState({
        //     from: newFrom,
        //     to: newTo,
        // });
        return {
          from: newFrom,
          to: to ? newTo : endDate,
          dateFromValue: !document.querySelector('html[lang="th"]') ? this.formatDate(newFrom) : this.formatDateThailan(newFrom),
          dateToValue: to ? (!document.querySelector('html[lang="th"]') ? this.formatDate(newTo) : this.formatDateThailan(newTo)) : "",
          showCalendar: false,
        };
      } else if (prevState.showCalendar === "to") {
        if (!from) return null;
        if ( startDate < from) return null;
        // if ( startDate && endDate && startDate <= from && startDate.getTime() === endDate.getTime()) {
        //   endDate = addDays(startDate, 1);
        //   newTo = endDate;
        // }
        // const dayThai = new Date(day);
        // dayThai.setFullYear(day.getFullYear() + 543);

        return {
          to: endDate,
          dateToValue: !document.querySelector('html[lang="th"]') ? this.formatDate(endDate) : this.formatDateThailan(endDate),
          showCalendar: false,
        };
      }
    }, () => {
      if (this.state.from && this.state.to) {
        const timeDiff = new Date(this.state.to) - new Date(this.state.from);
        const nbdays = timeDiff / (1000 * 60 * 60 * 24);
  
        let dateObj = {
          frommonth: new Date(this.state.from).getMonth() + 1,
          fromday: new Date(this.state.from).getDate(),
          fromyear: new Date(this.state.from).getFullYear(),
          tomonth: new Date(this.state.to).getMonth() + 1,
          dayto: new Date(this.state.to).getDate(),
          toyear: new Date(this.state.to).getFullYear(),
          nbdays: nbdays,
        };
  
        this.props.setCalendarData(dateObj);
      }
    });
  };  

  customNavigatorRenderer = (focusedDate, changeShownDate, props) => {
    const langThai = document.querySelector('html[lang="th"]');
    const year = focusedDate.getFullYear();
    const monthIndex = focusedDate.getMonth();
    
    let displayText;
    if (langThai) {
      const thaiYear = year + 543;
      const monthName = thaiMonths[monthIndex];
      displayText = `${monthName} ${thaiYear}`;
    } else {
      const monthName = englishMonths[monthIndex];
      displayText = `${monthName} ${year}`;
    }
    
    return (
      <div className="rdrMonthAndYearWrapper">
        <button 
          type="button" 
          className="rdrNextPrevButton rdrPprevButton"
          onClick={() => changeShownDate(-1, 'monthOffset')}
        >
          <i></i>
        </button>
        <span className="rdrMonthAndYearPickers">
          <span className="rdrMonthPicker">
            <span className="rdrMonthName">{displayText}</span>
          </span>
        </span>
        <button 
          type="button" 
          className="rdrNextPrevButton rdrNextButton"
          onClick={() => changeShownDate(+1, 'monthOffset')}
        >
          <i></i>
        </button>
      </div>
    );
  }

  render() {
    const { from, to, showCalendar, dateFromValue, dateToValue } = this.state;
    const selectedDays = [
      { startDate: from, 
        endDate: to,
        key: 'selection' }
    ];

    const langThai = document.querySelector('html[lang="th"]');
    const calendarElement = (
      <div className="calendar-wrapper calender-custom-wrapper calender-custom-mb-wrapper">
       <DateRangePicker 
          ranges={selectedDays}
          onChange={this.handleDayClick}
          minDate={
              showCalendar === "to"
              ? addDays(new Date(from), 1)
              : bookingStartDate(this.props.openingDate)
          }
          showPreview={true}
          showSelectionPreview={true}
          locale={langThai ? th : customEnglishLocale}
          monthDisplayFormat="MMMM yyyy"
          months={1}
          showMonthAndYearPickers={false}
          showDateDisplay={false}
          editableDateInputs={false}
          weekStartsOn={1}
          navigatorRenderer={this.customNavigatorRenderer}
          preventSnapRefocus
        />
      </div>
    );

    return (
      <div className="calendar-container custom-calendar-mb" ref={this.calendarRef}>
        <div className="input-container">
          <div className={`input-wrapper ${dateFromValue ? "has-value" : ""}`}>
            <label className="floating-label">Check-in Date</label>
            <span className="calender-icon" onClick={this.handleCalendarIconClick}></span>
            <input
              type="text"
              className="dates input-from"
              onFocus={() => this.handleInputFocus("from")}
              value={dateFromValue}
              readOnly
            />
             {showCalendar === "from" && calendarElement}
          </div>
          <div className={`input-wrapper ${dateToValue ? "has-value" : ""}`}>
            <label className="floating-label">{Drupal.t("Check-out Date")}</label>
            <span className="calender-icon" onClick={this.handleCalendarIconClick}></span>
            <input
              type="text"
              className="dates input-to"
              onFocus={() => this.handleInputFocus("to")}
              value={dateToValue}
              readOnly
            />
            {showCalendar === "to" && calendarElement}
          </div>
        </div>
      </div>
    );
  }
}

export default CalendarMobile;
